// eslint-disable-next-line import/prefer-default-export
export const ATTACHMENT_TYPE_DICT = {
  SIGNED_DOCUMENT: 'signed_document',
  DOCUMENT_OF_WORK: 'documentation_of_work',
  DOCUMENT_FOR_WORK: 'document_for_work',
};
